import script from "./auth-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./auth-dialog.vue?vue&type=style&index=0&id=7b42d640&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b42d640"]])

export default __exports__